import { create } from 'zustand';

type DesktopOpenPromptStore = {
  /**
   * Until the open-in-app offer decides whether to show for the page the user arrived on, which
   * waits for their profile. Install prompts wait too, so they never take the spot first.
   */
  isDeciding: boolean;
  /** Whether the open-in-app offer or its interstitial is on screen; install prompts wait for it. */
  isShowing: boolean;
};

export const useDesktopOpenPromptStore = create<DesktopOpenPromptStore>(() => ({
  isDeciding: true,
  isShowing: false,
}));
